<div class="page-not-found">
	<div class="error-alert">
		<span class="alert alert-danger">404</span>
	</div>
	<div class="error-message">
		<span>Page Does Not Exist</span>
	</div>
	<div class="error-link error-link--dashboard">
		<a *ngIf="!isAdmin" [routerLink]="['/pilotpay/dashboard']">Dashboard</a>
		<a *ngIf="isAdmin" [routerLink]="['/pilotpay/admin']">Dashboard</a>
	</div>
</div>
